import DesktopBanner from "../../../molecules/layouts/app/DesktopBanner";
import LanguageDropdown from "../../../molecules/dropdowns/LanguageDropdown";
import SupportButton from "../../../atoms/buttons/SupportButton";

const DesktopLayout = ({ children }) => {
  return (
    <div className="bg-gray-100 w-full flex justify-center min-h-screen py-10">
      <div className="bg-white rounded-none w-1/2 relative">
        <DesktopBanner />
        <div className="flex justify-end p-6">
          <LanguageDropdown />
        </div>
        <div className="flex justify-center">
          <div className="w-full max-w-lg">{children}</div>
        </div>
        <div className="absolute right-0 -bottom-0 p-6">
          <SupportButton />
        </div>
      </div>
    </div>
  );
};

export default DesktopLayout;
